"use client";

import { useEffect, useState } from "react";
import { LinkType } from "../../../sanity/lib/types/link";
import useIsMobile from "../../hooks/useIsMobile";
import LinkText from "../layoutModules/LinkText";
import { LinkElement } from "../link/link";
import { useAppContext } from "../../provider/AppProvider";

type Props = {
    title: string;
    text: string;
    mobileText: any;
    link?: LinkType;
    bgColors: Array<string>;
};

export const CtaBanner = ({ title, text, link, mobileText, bgColors }: Props) => {
    const { isBannerHidden, setIsBannerHidden, isInView } = useAppContext();
    const { isMobile } = useIsMobile();
    const { setBannerBgColor, bannerBgColor } = useAppContext();

    useEffect(() => {
        if (bannerBgColor === "") {
            setBannerBgColor(bgColors[Math.floor(Math.random() * bgColors.length)]);
        }
    }, [bannerBgColor]);

    if (isBannerHidden || !isInView) return <></>;

    return (
        <div
            style={{ "--banner-bg-color": bannerBgColor } as React.CSSProperties}
            className={`w-full bg-[var(--banner-bg-color)] cta-banner fixed bottom-0 z-40 flex gap-5 px-5 py-4 justify-between items-center`}
        >
            {isMobile ? (
                <div className="flex justify-between w-full gap-4">
                    <LinkText className="m-title-highlight" content={mobileText} />
                    <button className="cursor-pointer" onClick={() => setIsBannerHidden(true)}>
                        <img src="/icon_close.svg" alt="Close Banner" />
                    </button>
                </div>
            ) : (
                <>
                    <p className="d-headline-3 md:hidden xl:block">{title}</p>
                    <p className="d-body-m md:whitespace-break-spaces xl:whitespace-normal banner:whitespace-break-spaces md:m-title-highlight xl:d-body-m">
                        {text}
                    </p>

                    <div className="flex items-center gap-4">
                        {link && (
                            <LinkElement
                                className="whitespace-nowrap btn"
                                size="small"
                                link={link}
                            />
                        )}

                        <button
                            className="cursor-pointer min-w-8 min-h-8"
                            onClick={() => setIsBannerHidden(true)}
                        >
                            <img width="32" height="32" src="/icon_close.svg" alt="Close Banner" />
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};
